"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allocLanes = allocLanes;
function allocLanes(items, pad) {
    const groups = new Map();
    const lanes = [];
    const out = new Map();
    for (const it of [...items].sort((a, b) => a.lo - b.lo)) {
        if (it.group !== null && groups.has(it.group)) {
            const l = groups.get(it.group) ?? 0;
            out.set(it, l);
            lanes[l].push([it.lo, it.hi]);
            continue;
        }
        let l = 0;
        for (; l < lanes.length; l++) {
            if (lanes[l].every(([lo, hi]) => it.hi < lo - pad || it.lo > hi + pad)) {
                break;
            }
        }
        lanes[l] = lanes[l] ?? [];
        lanes[l].push([it.lo, it.hi]);
        out.set(it, l);
        if (it.group !== null) {
            groups.set(it.group, l);
        }
    }
    return { out, n: lanes.length };
}
//# sourceMappingURL=alloc-lanes.js.map